export default class PinTicketModel {
    pin: number = 0;
    header: string = "";
    bucketSize: string = "";
    balls: number = 0;
    expiration: string = "";
    pageBreak: boolean = false;
    isMinutes: boolean = false;
}